import React from 'react';

const VenueAnalytics: React.FC = () => {
  return (
    <section id='analytics' className='p-6 md:p-16 bg-[#CBD9FF]'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        {/* Header */}
        <p className='text-sm font-semibold uppercase'>Venue Analytics</p>
        <h2 className='text-4xl font-bold text-[#1d191f] w-5/6 my-4'>
          Gain insights into visitor behavior and preferences
        </h2>
        <p className='text-base font-semibold md:w-3/6 md:mb-16'>
          Understand how visitors interact with your space and tailor your
          offerings - increasing engagement, conversations, and revenue
        </p>

        {/* VIsitor Heat Map */}
        <div className='flex flex-col items-center justify-center mt-10 mb-10 md:items-start'>
          <p className='mb-2 text-lg font-bold'>Visitor Heat Map</p>
          <p className='mb-6 text-md'>
            Optimize engagement by seeing where visitors interact most
          </p>
          <img
            className='mx-auto md:max-w-2xl md:mx-0'
            alt=''
            src={'/analytics-card.png'}
          />
        </div>

        <p className='text-lg font-bold text-center md:text-left'>
          Analytics Available
        </p>

        {/* Analytics Grid */}
        <div className='grid items-center justify-center max-w-3xl grid-cols-2 mx-auto my-10 gap-x-10 gap-y-10 md:grid-cols-4 md:z-10 md:mx-0'>
          {/* Analytics Card */}
          <div className='flex flex-col items-start justify-start sm:w-40 sm:h-48 px-4 py-6 bg-white rounded-md shadow-md'>
            <img className='mb-2' alt='' src={'/line.svg'} />
            <p className='sm:text-lg font-bold'>
              Activity
              <br />
              Levels
            </p>
            <p className='text-md'>Gain insights into visitor behavior</p>
          </div>

          {/* Analytics Card */}
          <div className='flex flex-col items-start justify-start sm:w-40 sm:h-48 px-4 py-6 bg-white rounded-md shadow-md'>
            <img className='mb-2' alt='' src={'/line.svg'} />
            <p className='sm:text-lg font-bold'>
              Engagement
              <br />
              Levels
            </p>
            <p className='text-md'>Increase retention and loyalty</p>
          </div>

          {/* Analytics Card */}
          <div className='flex flex-col items-start justify-start sm:w-40 sm:h-48 px-4 py-6 bg-white rounded-md shadow-md'>
            <img className='mb-2' alt='' src={'/line.svg'} />
            <p className='sm:text-lg font-bold'>
              Feedback
              <br />
              Results
            </p>
            <p className='text-md'>See real-time visitor satisfaction</p>
          </div>

          {/* Analytics Card */}
          <div className='flex flex-col items-start justify-start sm:w-40 sm:h-48 px-4 py-6 bg-white rounded-md shadow-md'>
            <img className='mb-2' alt='' src={'/line.svg'} />
            <p className='sm:text-lg font-bold'>
              Visitor
              <br />
              Demographics
            </p>
            <p className='text-md'>Understand customers better</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VenueAnalytics;
